export default __webpack_public_path__ + "static/media/m-fsk-02.a1c43721.jpg";